import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import Link from 'next/link'
import cName from "classnames";
import styles from './index.module.scss';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Wrapper from '@/components/wrapper';
import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';
import request from '@/utils/request';
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface IProps {

}
export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data } = await request.get(`/api/get_summit_year`, {
    params: {
      lang: context.locale || 'cn'
    }
  })
  return {
    props: {
      ...res.props,
      data: data?.data || null
    }
  }
}

export default ({ menuDetail, data }: any) => {
  const router = useRouter();
  const t = useTranslations("summit.2025");

  useEffect(() => {
    setTimeout(() => {
      const str = document.getElementById("reactCode")?.innerText || 'console.log()';
      eval(str)
    }, 500);
  }, [menuDetail]);

  const chunkArray = useCallback((arr: any, chunkSize: number) => {
    const chunkedArray = [];
    let index = 0;
    while (index < arr.length) {
      const end = Math.min(index + chunkSize, arr.length);
      chunkedArray.push(arr.slice(index, end));
      index = end;
    }
    return chunkedArray;
  }, [])

  return (
    <div>
      <Wrapper banner="" showCrumb={false} showPendant={false}>
        <div className={styles.container}>
          {getHead(menuDetail)}
          <div className={styles.bg}>
            <img src="/image/summit-2025-bg2.png" alt="" />
            <img src="/image/summit-2025-bg4.png" alt="" />
          </div>
          <div className={styles.intro}>
            <div className="m-1600">
              <div className={styles.text}>
                <img src="/image/footer-logo-2027.png?v=20250422" alt="" />
                <h2>{t('title')}</h2>
                {/* <ul>
                  <li>
                    <div>
                      <p><CountUp
                        end={30}
                        duration={1}
                        enableScrollSpy
                      /><span>+位</span></p>
                      <span>专家学者</span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <p><CountUp
                        end={7}
                        duration={1}
                        enableScrollSpy
                      /><span></span></p>
                      <span>大行业模块</span>
                    </div>
                  </li>
                </ul> */}
                <p>{t('text')}</p>
              </div>
              <div className={styles.vLogo}>
                <h3>{t('section1.title')}</h3>
                <div>
                  <Swiper
                    className={styles.swiper}
                    modules={[Autoplay, Pagination]}
                    spaceBetween={0}
                    autoplay
                    pagination={{ clickable: true }}
                    slidesPerView={1}
                  >
                    {
                      data.spectator_list &&
                      chunkArray(data.spectator_list, 24)
                        ?.map((item: any, index: number) => (
                          <SwiperSlide key={index}>
                            <ul className={styles.audiList}>
                              {
                                item.map((child: any, idx: number) => (
                                  <li key={idx}>
                                    <Link href={child[`link_${router.locale}`] ? child[`link_${router.locale}`] : "javascript:;"}>
                                      <a target={child[`link_${router.locale}`] ? '_blank' : '_self'}>
                                        <img loading='lazy' src={child.image} alt={child[`title_${router.locale}`]} />
                                      </a>
                                    </Link>
                                  </li>
                                ))
                              }
                            </ul>
                          </SwiperSlide>
                        ))
                    }
                  </Swiper>
                </div>
              </div>
            </div>
            <img loading='lazy' src="/image/summit-2025-bg.png" alt="" />
          </div>
          <div className={cName(styles.vComment, 'm-1600')}>
            <h3>{t('section2.title')}</h3>
            <div>
              <div className={styles.left}>
                <Swiper
                  autoplay
                  className='comment'
                  modules={[Pagination]}
                  slidesPerView={1}
                  pagination={{ clickable: true }}
                >
                  <SwiperSlide>
                    <div className={styles.swiperItem}>
                      <div className={styles.logo}>
                        <div>
                          <img src="https://img.cbcechina.com/2025-07-18/c1784f0aeb59543de9bbffa8aa63bfbc.png" alt="" />
                        </div>
                      </div>
                      <div className={styles.text}>
                        <p className={styles.name}>{t('section2.list.item1name')}</p>
                        <p className={styles.position}>{t('section2.list.item1label')}</p>
                        <p>{t('section2.list.item1txt')}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.swiperItem}>
                      <div className={styles.logo}>
                        <div>
                          <img src="https://img.cbcechina.com/2024-12-02/a3821d8ff44dbf6191be37b1c5f253e5.png" alt="" />
                        </div>
                      </div>
                      <div className={styles.text}>
                        <p className={styles.name}>{t('section2.list.item2name')}</p>
                        <p className={styles.position}>{t('section2.list.item2label')}</p>
                        <p>{t('section2.list.item2txt')}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
              <div className={styles.right}>
                <Swiper
                  autoplay
                  modules={[Pagination]}
                  slidesPerView={1}
                  className='comment'
                  autoHeight={true}
                  pagination={{ clickable: true }}
                >
                  <SwiperSlide>
                    <div className={styles.swiperItem}>
                      <div className={styles.logo}>
                        <div>
                          <img src="https://img.cbcechina.com/2024-12-02/6709cfb7f2c2f6c42ff07fc3fd504e95.png" alt="" />
                        </div>
                      </div>
                      <div className={styles.text}>
                        <p className={styles.name}>{t('section2.list.item3name')}</p>
                        <p className={styles.position}>{t('section2.list.item3label')}</p>
                        <p>{t('section2.list.item3txt')}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.swiperItem}>
                      <div className={styles.logo}>
                        <div>
                          <img src="https://img.cbcechina.com/2024-12-02/6c2a27c4c21a87c692328800d2b11376.png" alt="" />
                        </div>
                      </div>
                      <div className={styles.text}>
                        <p className={styles.name}>{t('section2.list.item4name')}</p>
                        <p className={styles.position}>{t('section2.list.item4label')}</p>
                        <p>{t('section2.list.item4txt')}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
          <img className={cName(styles.photo_wall, styles.full)} src="https://img.cbcechina.com/2025-07-18/8094adfedea5c88f63040483ca0fb4d2.png" alt="" />
          <img className={cName(styles.photo_wall, styles.part)} src="/image/summit-2025-bg5.png" alt="" />
          <img className={cName(styles.photo_wall, styles.part)} src="/image/summit-2025-bg6.png" alt="" />
          <div dangerouslySetInnerHTML={{
            __html: menuDetail?.info?.content
          }} />
          <div className={cName(styles.sponsor, 'm-1600')}>
            <h3>{t('section3.title')}</h3>
            <Swiper
              className={styles.swiper}
              modules={[Autoplay, Pagination]}
              spaceBetween={0}
              autoplay
              pagination={{ clickable: true }}
              slidesPerView={1}
            >
              {
                data.brand_list &&
                chunkArray(data.brand_list, 6)
                  ?.map((item: any, index: number) => (
                    <SwiperSlide key={index}>
                      <ul className={styles.audiList}>
                        {
                          item.map((child: any, idx: number) => (
                            <li key={idx}>
                              <Link href={child[`link_${router.locale}`] ? child[`link_${router.locale}`] : "javascript:;"}>
                                <a target={child[`link_${router.locale}`] ? '_blank' : '_self'}>
                                  <img loading='lazy' src={child.image} alt={child[`title_${router.locale}`]} />
                                </a>
                              </Link>
                            </li>
                          ))
                        }
                      </ul>
                    </SwiperSlide>
                  ))
              }
            </Swiper>
          </div>
          {/* <div className={styles.lookback}>
            <h3>更多精彩回顾</h3>
            <Swiper
              onObserverUpdate={(swiper: any) => {
                swiper.slideNext()
              }}
              autoplay
              className='lookback'
              modules={[Autoplay, Pagination]}
              slidesPerView='auto'
              pagination={{ clickable: true }}
            >
              {
                data.review_list?.map((item: any, index: number) => (
                  <SwiperSlide key={item.id}>
                    <a href={item.file} style={{
                      opacity: `${1 - index * 0.09}`
                    }} target='_blank' className={styles.lookItem}>
                      <p>{item.title}<span>年</span></p>
                      <span>峰会回顾</span>
                      <div className={styles.bg}></div>
                    </a>
                  </SwiperSlide>

                ))
              }
            </Swiper>
          </div> */}
          <style jsx global lang='scss'>
            {
              `
              .lookback .swiper-wrapper :first-child a{
                 background-image: url(/image/lookback-li-first-bg.png);
                 background-size: 100% 100%;
              }
              .swiper-slide{
                width:auto;
                // padding-bottom:30px;
              }
              
              .comment .swiper-pagination{
                bottom: 20px !important;
                left:200px !important;
                text-align:left !important;
              }
              .swiper-pagination-bullet{
                width: 40px;
                height: 6px;
                border-radius: 2px;
                background-color: #231f20;
              }
              .swiper-pagination-bullet{
                background-color: rgb(255 255 255 / 80%);
              }
              .swiper-pagination-bullet-active{
                background-color:#F6A800 !important;
              }
              
              @media screen and (min-width: 1000px) {
                .comment,
                .comment .swiper-wrapper,
                .comment .swiper-slide{
                  height:100% !important;
                }
              }
              @media screen and (max-width: 500px) {
                .comment .swiper-pagination{
                  left:0 !important;
                  text-align:center !important;
                }
              }
            `
            }
          </style>
        </div>
      </Wrapper>
    </div>
  );
};